module.exports = "<div class=\"holder\" [ngClass]=\"{'right': position == 'right', 'left': position == 'left'}\">\n  <div class=\"inner\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/bar/bar.component.html
// module id = ./src/app/components/editor/bar/bar.component.html
// module chunks = main